import React from 'react';
import { FiCheck, FiAlertCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

/**
 * Compact booking status badge for round cards
 * @param {boolean} isBooked - Whether the round is booked
 * @param {string} variant - 'badge' (default) or 'inline' (no background)
 * @param {string} size    - 'sm' (default, text-xs) or 'md' (text-base, matches body)
 */
function BookingStatusBadge({ isBooked, variant = 'badge', size = 'sm' }) {
  const colour = isBooked ? 'text-status-success' : 'text-status-warning';
  const bg = isBooked ? 'bg-status-success/10' : 'bg-status-warning/10';

  const textClass = size === 'md' ? 'text-base font-semibold' : 'text-xs font-medium';
  const iconClass = size === 'md' ? 'w-4 h-4 mr-1.5' : 'w-3.5 h-3.5 mr-1.5';

  if (variant === 'inline') {
    return (
      <span className={`inline-flex items-center ${textClass} ${colour}`}>
        <SafeIcon
          icon={isBooked ? FiCheck : FiAlertCircle}
          className={size === 'md' ? 'w-4 h-4 mr-1.5' : 'w-3.5 h-3.5 mr-1'}
        />
        {isBooked ? 'Booked' : 'Not booked'}
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center rounded-lg ${bg} ${colour} ${textClass} ${size === 'md' ? 'px-3 py-1' : 'px-2.5 py-1'}`}>
      <SafeIcon
        icon={isBooked ? FiCheck : FiAlertCircle}
        className={iconClass}
      />
      {isBooked ? 'Booked' : 'Not booked'}
    </div>
  );
}

export default BookingStatusBadge;
